// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
/**
 * Coverage breakdown for a single configuration. Shows execution statistics aggregated across all test plans in the release that use this configuration.
 * @export
 * @interface ReleaseReadinessConfigurationCoverage
 */
export interface ReleaseReadinessConfigurationCoverage {
  /**
   * The ID of the test plan configuration
   * @type {number}
   * @memberof ReleaseReadinessConfigurationCoverage
   */
  configurationId: number;
  /**
   * Key-value pairs defining the configuration. E.g. {\"browser\": \"Chrome\", \"os\": \"Windows\"}.
   * @type {{ [key: string]: string; }}
   * @memberof ReleaseReadinessConfigurationCoverage
   */
  parameters: { [key: string]: string };
  /**
   * The test plan this configuration belongs to
   * @type {number}
   * @memberof ReleaseReadinessConfigurationCoverage
   */
  testPlanId?: number;
  /**
   * Title of the test plan
   * @type {string}
   * @memberof ReleaseReadinessConfigurationCoverage
   */
  testPlanTitle?: string;
  /**
   * Total test cases for this configuration
   * @type {number}
   * @memberof ReleaseReadinessConfigurationCoverage
   */
  total: number;
  /**
   * Number of test cases executed
   * @type {number}
   * @memberof ReleaseReadinessConfigurationCoverage
   */
  executed: number;
  /**
   * Number of test cases passed
   * @type {number}
   * @memberof ReleaseReadinessConfigurationCoverage
   */
  passed: number;
  /**
   * Number of test cases failed
   * @type {number}
   * @memberof ReleaseReadinessConfigurationCoverage
   */
  failed: number;
  /**
   * Pass rate as a percentage (passed / executed * 100)
   * @type {number}
   * @memberof ReleaseReadinessConfigurationCoverage
   */
  passRate: number;
}

export function ReleaseReadinessConfigurationCoverageFromJSON(
  json: any
): ReleaseReadinessConfigurationCoverage {
  return {
    configurationId: json["configuration_id"],
    parameters: json["parameters"],
    testPlanId: !exists(json, "test_plan_id")
      ? undefined
      : json["test_plan_id"],
    testPlanTitle: !exists(json, "test_plan_title")
      ? undefined
      : json["test_plan_title"],
    total: json["total"],
    executed: json["executed"],
    passed: json["passed"],
    failed: json["failed"],
    passRate: json["pass_rate"],
  };
}

export function ReleaseReadinessConfigurationCoverageToJSON(
  value?: ReleaseReadinessConfigurationCoverage
): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    configuration_id: value.configurationId,
    parameters: value.parameters,
    test_plan_id: value.testPlanId,
    test_plan_title: value.testPlanTitle,
    total: value.total,
    executed: value.executed,
    passed: value.passed,
    failed: value.failed,
    pass_rate: value.passRate,
  };
}
